// uxStore — small zustand slice for UX v0.7 per-project state that the
// legacy backend doesn't persist (shape id + audience tags). We use
// localStorage so the Command Center can recall the shape after reload.

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ShapeId, AudienceTag } from '@/components/intake/shapes'

interface ProjectUxState {
  shape: ShapeId | null
  audience: AudienceTag[]
  vertical: string | null
}

interface UxStore {
  /** Per-project UX state keyed by project_id. */
  projects: Record<string, ProjectUxState>
  setShape: (projectId: string, shape: ShapeId | null) => void
  setAudience: (projectId: string, audience: AudienceTag[]) => void
  setVertical: (projectId: string, vertical: string | null) => void
  get: (projectId: string) => ProjectUxState
}

const DEFAULT_STATE: ProjectUxState = { shape: null, audience: [], vertical: null }

export const useUxStore = create<UxStore>()(
  persist(
    (set, getter) => ({
      projects: {},
      setShape: (projectId, shape) =>
        set((s) => ({
          projects: {
            ...s.projects,
            [projectId]: { ...(s.projects[projectId] ?? DEFAULT_STATE), shape },
          },
        })),
      setAudience: (projectId, audience) =>
        set((s) => ({
          projects: {
            ...s.projects,
            [projectId]: { ...(s.projects[projectId] ?? DEFAULT_STATE), audience },
          },
        })),
      setVertical: (projectId, vertical) =>
        set((s) => ({
          projects: {
            ...s.projects,
            [projectId]: { ...(s.projects[projectId] ?? DEFAULT_STATE), vertical },
          },
        })),
      get: (projectId) => getter().projects[projectId] ?? DEFAULT_STATE,
    }),
    { name: 'ai_alm_ux_v07' },
  ),
)
